import analysis from '!svg-inline-loader!../../../assets/icons/icon_analysis.svg';
import cohort from '!svg-inline-loader!../../../assets/icons/icon_cohort.svg';

export const icons = {
  analysis,
  cohort,
};
